import React, { useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import AddQuizForm from "./AddQuizForm";
import { Modal } from "react-bootstrap";
import CustomButton from "../../../../components/Button/Button";

import "./AddQuizCollection.scss";

let answerPrototype = {
  question: "",
  description: "",
  level: 1,
  answer: "",
  reference: ""
};

export default function AddQuizCollection({ postData, isLoading }) {
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
  const [selectedQuestion, setSelectedQuestion] = useState<{
    id?: string;
    index?: number;
  }>({});
  const [loading, setLoading] = useState<boolean>(false);

  const {
    control,
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors }
  } = useForm({
    defaultValues: {
      contents: [answerPrototype]
    }
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "contents"
  });

  const addNewQuestion = event => {
    event.preventDefault();
    append(answerPrototype);
  };

  const toggleDeleteModal = (selectedData?: { id: string; index?: number }) => {
    setShowDeleteModal(preState => !preState);
    if (selectedData) setSelectedQuestion(selectedData);
  };

  const confirmDelete = () => {
    toggleDeleteModal();
    console.log(selectedQuestion, "selected question");
    if (selectedQuestion?.id) {
      remove(+selectedQuestion?.id);
    }
  };

  const renderQuestions = () => {
    return fields.map((question, index) => {
      return (
        <AddQuizForm
          key={question.id}
          id={question.id}
          register={register}
          index={index}
          setValue={setValue}
          errors={errors}
          handleDelete={toggleDeleteModal}
          getValues={getValues}
        />
      );
    });
  };
  return (
    <div className="questions_container">
      <form onSubmit={handleSubmit(postData)}>
        {renderQuestions()}
        <button className="add_new_question_button" onClick={addNewQuestion}>
          +
        </button>
        <div className="add_button_container">
          <div className="submit_button_wrapper">
            <CustomButton
              type="submit"
              color="success"
              filledButton={true}
              disabled={isLoading ? true : false}
              clickHandler={() => {}}
              buttonName={isLoading ? "Submitting" : "Submit"}
            />
          </div>
        </div>
      </form>
      <Modal
        className="modal-box"
        show={showDeleteModal}
        onHide={toggleDeleteModal}
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure to delete question "
          {selectedQuestion.index ? selectedQuestion.index + 1 : ""}" ?
        </Modal.Body>
        <Modal.Footer>
          <div className="button_wrapper">
            <div className="btn_yes">
              <CustomButton
                type="button"
                buttonName="Confirm"
                color="danger"
                clickHandler={confirmDelete}
                filledButton={true}
              />
            </div>
            <div className="btn_no">
              <CustomButton
                type="button"
                buttonName="Cancel"
                color="success"
                clickHandler={toggleDeleteModal}
                filledButton={false}
              />
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
}
